import { Component, OnInit } from '@angular/core';
import { TemaService } from './core/services/tema.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'parkingHubGestao';

  constructor(private temaService: TemaService) {}

  ngOnInit() {
    this.temaService.aplicarTemaDefault();
    localStorage.setItem('usuarioTipo', 'PJ');
  }
}
